
import img1 from './assets/img2.jpg'
import img2 from './assets/img2.jpg'
import img3 from './assets/img3.jpg'
import img4 from './assets/img4.jpg'

import review1 from './assets/rev1.png'
import review2 from './assets/rev2.png'


export const dummyData =
{
    title1: 'Our Recent',
    title2: 'Work',
    sliderData: [
        {
            title: 'Zemaa entertainment',
            img: [
                img1,
                img2
            ],
            desc: 'CodeZone has developed an amazing and incredible project and solved the problem of the 24/7 live streaming on youtube and Facebook. With the help of the zemaa entertainment plateform the user can do the live stream 24/7 for any number of days according to his plan.',
            link: 'https://zemas.live'
        },
        {
            title: 'LingoTalker',
            img: [
                img3,
                img4
            ],
            desc: 'Lingo Talker is an educational plateform having amazing and incredible functionalities. On this platform any teacher from any region of the world can register and can teach any student from any region of the world and can earn revenue.',
            link: 'https://app.lingotalker.com/'
        },
    ]
}

export const reviewData = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [
        {
            img: 'https://images.unsplash.com/photo-1629393587517-19cd2e98b2b0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHVzYSUyMGZsYWd8ZW58MHx8MHx8&w=1000&q=80',
            desc: 'CodeZone always provides excellent quality of work. Very Proactive to Client needs',
            rating: 5,
            country: 'USA'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTedMEhnYyMDXrmPyu68m32qbRkDG0bUKS0Q&usqp=CAU',
            desc: "Creative, responsive and energetic to bring my story to life. I'm blown away. Thank you so much for doing the excellent job for me. Excellent communication and fast deleivery.",
            rating: 5,
            country: 'Canada'

        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBsiNMALQdlyt5FBexnrC4CBM9IJWEM8MWuQ&usqp=CAU',
            desc: 'Very thorough and well documented. I highly recommend',
            rating: 5,
            country: 'Australia'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRa5uExCbQqdGcPnOqmOIr2m41XJ-A_-5lqg&usqp=CAU',
            desc: 'This was my first experience working with CodeZone and he exceeded my expectations in every way. He created a nice and interesting story. He was very kind, responsive and prepared to listen adn follow my instructions. Truly professional. 100% recommended. Thank you a lot',
            rating: 5,
            country: 'Turkey'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: 'CodeZone has solved my complex problem. Fantastic work has been done. Highly recommended',
            rating: 4.5,
            country: 'UK'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeOt6ZDhLOPYACaMDH8sq_YWbNO9YckQduDw&usqp=CAU',
            desc: "Excellent work. Sent back what was required very quickly and to a high standard",
            rating: 5,
            country: 'Spain'

        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHdWNvw0x6OKcia5lhbvNRfhusRxLPNEZPJg&usqp=CAU',
            desc: 'Consistent quality over time.',
            rating: 4,
            country: 'Ireland'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQjMvuucJbnQNnATqJ4OADV7Gkuhkd8-aybg&usqp=CAU',
            desc: "I've worked with a lot of designers in the past, but none have been as responsive and helpful as they were. I wouldn't hesitate to work with them again.",
            rating: 5,
            country: 'Latvia'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: "CodeZone always provides excellent quality of work. Very Proactive to Client needs",
            rating: 5,
            country: 'UK'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeOt6ZDhLOPYACaMDH8sq_YWbNO9YckQduDw&usqp=CAU',
            desc: "I'm delighted and proud of the finished product. It is exactly as i imagined it to be. Their communication, professionalism, and delivery are all five stars. I trusted the seller with my dream and he fulfilled it exactly as I had imagined.",
            rating: 5,
            country: 'Spain'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRde_bh9lfxlYRcdCzRQN81aJITh1NTcIEnxw&usqp=CAU',
            desc: "I always expect an excellent result and product when i place the project with CodeZone. They respond quickly and handled my project confidently and professionally. I would recommend who requires professional services.",
            rating: 5,
            country: 'Kwait'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxLThUGOpD_hZnWr4krYbh5GC0AilFP4ZxtQ&usqp=CAU',
            desc: "Excellent output and very professional. Highly recommended.",
            rating: 5,
            country: 'UAE'
        },

        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjDZnxxBKy27jD-5OnNN13MVIkYtNQpxZRzQ&usqp=CAU',
            desc: "Some of the top-notch work on the planet.",
            rating: 5,
            country: 'Nether Land'
        },

        {
            img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAACqCAMAAABVlWm8AAAACVBMVEXIEC7////aYHQhaz+vAAAAgUlEQVR4nO3bAQ3AMAzAsH78QQ/AAXRSbAYBkBkAAAAAAAAAAAAAAAAA4Dmnbb42/W362/S36W/T36a/TX+b/jb9bfrb9Lfpb9Pfpr9Nf5v+Nv1t+tv0t+lv09+mv01/m/42/W362/S35fu3B8Rl2/spAAAAAAAAAAAAAAAAAPB3Aee3O8UTMv89AAAAAElFTkSuQmCC',
            desc: "Very friendly and always here to clarify any questions and concerns. Really amazing to work with. I will surely work with him on upcoming projects",
            rating: 5,
            country: 'Austria'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQ1mLzxtvrb-YFvd3dWN7YpS1WyCKUshVDHg&usqp=CAU',
            desc: "CodeZone has done such an amazing job and develop a fantastic and professional NFT marketplace. He was being very friendly and creative. Value for your money. 100% recommended. I would love to work with CodeZone again in the future.",
            rating: 5,
            country: 'France'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: 'I have hired Dawood and his company CodeZone for one of our recent projects, which involved developing an educational platforms connecting teachers and students from around the world in one platform. Dawood did a fantastic job and was supportive throughout the whole project. He responds timely and also worked us with when we encountered any challenges with our project. Overall, I was very satisfied with their team’s dedication and would certainly recommend it to anyone who is looking to build any innovative projects.',
            rating: 5,
            country: 'UK'
        },

    ]
}
export const dummyReviews = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [

        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTedMEhnYyMDXrmPyu68m32qbRkDG0bUKS0Q&usqp=CAU',
            desc: "Creative, responsive and energetic to bring my story to life. I'm blown away. Thank you so much for doing the excellent job for me. Excellent communication and fast deleivery.",
            rating: 5,
            country: 'Canada'

        },

        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: 'This was my first experience working with CodeZone and he exceeded my expectations in every way. He created a nice and interesting story. He was very kind, responsive and prepared to listen adn follow my instructions. Truly professional. 100% recommended. Thank you a lot',
            rating: 5,
            country: 'UK'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: 'CodeZone has solved my complex problem. Fantastic work has been done. Highly recommended',
            rating: 5,
            country: 'UK'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTedMEhnYyMDXrmPyu68m32qbRkDG0bUKS0Q&usqp=CAU',
            desc: "Excellent work. Sent back what was required very quickly and to a high standard",
            rating: 5,
            country: 'Canada'

        },

    ]
}